import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Plus } from 'lucide-react';

interface CourseNotFoundProps {
  onAddCourse?: () => void;
}

export function CourseNotFound({ onAddCourse }: CourseNotFoundProps) {
  return (
    <div className="min-h-[400px] flex flex-col items-center justify-center text-center p-8">
      <div className="bg-[#373737] rounded-full p-4 mb-6">
        <BookOpen className="h-8 w-8 text-[#d8f477]" />
      </div>
      
      <h2 className="text-2xl font-bold text-black mb-4">
        No Courses Found
      </h2>
      
      <p className="text-black mb-8 max-w-md">
        Get started by creating your first course. Add course content, modules, and lessons to begin building your educational platform.
      </p>
      
      {onAddCourse ? (
        <button
          onClick={onAddCourse}
          className="inline-flex items-center px-6 py-3 bg-[#d8f477] text-black font-medium rounded-xl hover:opacity-90 transition-all"
        >
          <Plus className="h-5 w-5 mr-2" />
          Create First Course
        </button>
      ) : (
        <Link
          to="/admin/courses/new"
          className="inline-flex items-center px-6 py-3 bg-[#d8f477] text-black font-medium rounded-xl hover:opacity-90 transition-all"
        >
          <Plus className="h-5 w-5 mr-2" />
          Create First Course
        </Link>
      )}
    </div>
  );
}